import { actionCreator,
  API_URL,
  checkHttpStatus,
  create_post_data,
  createRequestActionTypes,
  createSearchUrl,
  jsonApiHeader, 
  showSuccessMessage,
  showErrorMessage,
  showWarningMessage,
} from './../../../../../actions/utilAction';
export { jsonApiHeader,
  actionCreator,
  checkHttpStatus,
  createSearchUrl,
  create_post_data,
  showSuccessMessage,
  API_URL,
  showErrorMessage,
  showWarningMessage,
};

export const GET_MASTER_TAGS_LIST_API = `${API_URL}/MasterTag/GetMasterTag`;
export const POST_MASTER_TAG_API = `${API_URL}/MasterTag/SaveMasterTag`;
export const GET_MASTER_TAG_DETAILS_API = `${API_URL}/MasterTag/GetMasterTagById`;
export const DELETE_MASTER_TAG_API = `${API_URL}/MasterTag/DeleteMasterTag`;
export const GET_MASTERDATABYNAME = `${API_URL}/api/MasterData/MasterDataByName`;
export const manageTagActionTypes = {
  get_masterdata: createRequestActionTypes('GET_MASTER_DATA'),
  get_masterTagsList: createRequestActionTypes('GET_MASTERTAGSLIST'),
  post_masterTag: createRequestActionTypes('POST_MASTERTAG'),
  get_masterTagDetails: createRequestActionTypes('GET_MASTERTAGDETAILS'),
  delete_masterTag: createRequestActionTypes('DELETE_MASTERTAG'),
};
export const MODULE = 'MASTER_MANAGETAG';



// WEBPACK FOOTER //
// ./src/modules/Masters/components/manageTags/constants/ApiConstants.js